import { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from "../components/ui/accordion";
import ComplianceStrip from "../components/ComplianceStrip";
import Seo from "../components/Seo";
import { FAQS as faqs } from "../content/site";

const FAQs = () => {
  const { hash } = useLocation();
  const [open, setOpen] = useState(hash ? decodeURIComponent(hash.slice(1)) : "");
  useEffect(() => {
    if (hash) setOpen(decodeURIComponent(hash.slice(1)));
  }, [hash]);

  return (
    <div className="mp-container py-14 max-w-3xl">
      <Seo
        title="Mortgage FAQs — plain-English answers"
        description="Clear, calm answers to common UK mortgage questions. Is MortgagePath a broker? Does it affect my credit score? Is the Snapshot free? Educational only — not regulated advice."
        path="/faqs"
      />
      <div className="text-xs uppercase tracking-widest text-[#0F766E]">FAQs</div>
      <h1 className="font-sora mt-3 text-4xl sm:text-5xl font-bold tracking-tight text-[#0B1220]">Mortgage FAQs</h1>
      <p className="mt-4 text-[#475569]">Clear, calm answers — written in plain English.</p>

      <div className="mp-card p-2 sm:p-4 mt-10">
        <Accordion type="single" collapsible value={open} onValueChange={setOpen} className="w-full">
          {faqs.map((f, i) => (
            <AccordionItem key={f.q} value={`faq-${i}`} id={`faq-${i}`} className="scroll-mt-24" data-testid={`faq-item-${f.q}`}>
              <AccordionTrigger className="text-left font-sora text-base sm:text-lg text-[#0B1220] px-4">{f.q}</AccordionTrigger>
              <AccordionContent className="text-[#475569] leading-relaxed px-4 pb-4">{f.a}</AccordionContent>
            </AccordionItem>
          ))}
        </Accordion>
      </div>

      <div className="mt-8"><ComplianceStrip /></div>
    </div>
  );
};

export default FAQs;
